import { render } from "./historylog-overview.vue?vue&type=template&id=3240b339"
import script from "./historylog-overview.vue?vue&type=script&lang=js"
export * from "./historylog-overview.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__